/** API route map: URLS.Controller.JobCustomTemplate */
export const JobCustomTemplate = {
      Name: 'JobCustomTemplate/',
      GetAllJobCustomTemplateListByClient: 'get-all-job-custom-templates-list-by-clientId',
      GetAllJobCustomTemplate: 'get-all-job-custom-templates',
      AddJobCustomTemplate: 'add-job-custom-template',
      UpdateJobCustomTemplate: 'update-job-custom-template',
      DeleteJobCustomTemplate: 'delete-job-custom-template',
};
